/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const EyeImpaired = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.535 16.535L21.0919 22.0919L22.1525 21.0312L3.06066 1.93933L2 2.99999L6.98083 7.98082C3.53793 9.43677 2 12 2 12C2 12 5 17 12 17C13.3179 17 14.494 16.8228 15.535 16.535ZM13.9241 14.9241L9.07588 10.0759C8.71186 10.628 8.5 11.2892 8.5 12C8.5 13.933 10.067 15.5 12 15.5C12.7108 15.5 13.372 15.2881 13.9241 14.9241ZM7.8172 14.7404C6.79139 14.338 5.95415 13.8223 5.28957 13.311C4.6803 12.8424 4.21421 12.3755 3.88381 12C4.21421 11.6245 4.6803 11.1576 5.28957 10.6889C5.95415 10.1777 6.79139 9.66195 7.8172 9.25957C7.30053 10.0466 7 10.9882 7 12C7 13.0118 7.30053 13.9534 7.8172 14.7404Z"
                        fill={color}
                    />
                    <path
                        d="M22 12C22 12 20.8854 13.8577 18.4297 15.3084L17.3293 14.208C17.8537 13.9242 18.313 13.6168 18.7104 13.311C19.3476 12.8209 19.8282 12.3327 20.1607 11.949C19.8706 11.5859 19.4493 11.1304 18.8755 10.6713C18.1979 10.1293 17.2928 9.56972 16.1118 9.15441C16.6718 9.96209 17 10.9427 17 12C17 12.5643 16.9065 13.1068 16.7342 13.6128L15.4817 12.3603C15.4938 12.2419 15.5 12.1217 15.5 12C15.5 10.067 13.933 8.49998 12 8.49998C11.8783 8.49998 11.7581 8.50619 11.6396 8.51831L10.2322 7.11087C10.7905 7.03927 11.3795 6.99998 12 6.99998C19.5 6.99998 22 12 22 12Z"
                        fill={color}
                    />
                </svg>
        );
    };
